import type { IconData } from '@stacksjs/iconify-core'

export const coffeeBean: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M35.2 36.868c-7.368 7.309-18.188 11.025-25.85 4.025a35 35 0 0 1-2.243-2.243c-7-7.662-3.284-18.482 4.025-25.85a305 305 0 0 1 1.668-1.668C20.168 3.822 30.988.107 38.65 7.107a35 35 0 0 1 2.243 2.243c7 7.662 3.284 18.482-4.025 25.85a306 306 0 0 1-1.668 1.668\"/><path d=\"M40.69 9.1C32.536 9.973 26.427 14.62 24 24S15.465 38.027 7.309 38.9\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default coffeeBean
